app.controller('BrowsePropertySolutionController', ['$rootScope', '$scope', function ($rootScope, $scope) {

    $scope.solution_model = $rootScope.factory.solution.getModel($scope.navigation_ids);


}])